import { Avatar, Button } from "@smart/itops-sb-design-system-dom";

import { AvailableField } from "./add-field-helpers";
import { fieldComponentIcons } from "../../constants";

export type AddFieldSectionProps = {
  rows: AvailableField[];
  onAdd: (name: string) => void;
  onDismiss: () => void;
};

export const AddFieldSection = ({
  rows,
  onAdd,
  onDismiss,
}: AddFieldSectionProps) => (
  <div
    className="flex flex-col gap-small p-[0.8rem] rounded border-solid border border-neutral-100"
    data-testid="add-field-section"
  >
    <div className="flex items-center gap-small">
      <span
        className="flex-1 text-caption font-semibold uppercase tracking-wide text-neutral-600"
        data-testid="add-field-section-heading"
      >
        Add a field
      </span>
      <Button
        aria-label="dismiss add a field"
        leftIcon="regularXmark"
        variant="secondarySubtle"
        size="small"
        dataTestId="dismiss-add-field-section"
        className="mr-[0.8rem]"
        onClick={onDismiss}
      />
    </div>
    {rows.length ? (
      <div className="flex flex-col">
        {rows.map((row, index) => (
          <div
            key={row.name}
            className="flex items-center gap-small px-[0.8rem] py-[0.8rem] rounded bg-white hover:bg-neutral-20"
            data-testid={`add-field-item-${index}`}
          >
            <div className="flex items-center gap-small overflow-hidden flex-1">
              <Avatar
                size={24}
                icon={fieldComponentIcons[row.type].name}
                bgColor={fieldComponentIcons[row.type].bgColor}
                tabIndex={-1}
              />
              <span className="font-semibold truncate" title={row.label}>
                {row.label}
              </span>
            </div>
            <Button
              aria-label={`add ${row.label}`}
              leftIcon="regularPlus"
              variant="primarySubtle"
              size="small"
              dataTestId={`add-field-${index}`}
              onClick={() => onAdd(row.name)}
            />
          </div>
        ))}
      </div>
    ) : (
      <span
        className="px-[0.8rem] py-[0.8rem] text-caption text-neutral-400"
        data-testid="add-field-empty-state"
      >
        No more fields to add
      </span>
    )}
  </div>
);
